import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const LabelsShowModeWrapper = styled(Box)`
  height: 100%;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.medium}px;

  .show-mode-content {
    overflow-y: auto;
    height: calc(100vh - 234px);
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.small}px;
    padding-bottom: 20px;

    .info {
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 20px;
      letter-spacing: 0.1px;
    }

    ::-webkit-scrollbar {
      display: none;
    }
  }

  .create-label-form {
    height: 100%;
  }
`

export const CreateLabelWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xSmall}px;

  .create-label-button {
    width: 100%;
  }

  .create-button {
    width: 50%;
  }
`

export const CreateLabelsInnerForm = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.medium}px;
  height: 100%;

  .form-control-label {
    color: ${theme.colors.menuItemText};
    font-family: Quicksand, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
  }

  .text-field-custom-label-form-control {
    gap: 8px;
  }

  .MuiOutlinedInput-root {
    .MuiOutlinedInput-input {
      color: #e9e0e4;
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px;

      &::placeholder {
        color: #d0c3cc !important;
        -webkit-text-fill-color: #d0c3cc !important;
        font-family: Quicksand, sans-serif !important;
        font-size: 14px !important;
        font-style: normal !important;
        font-weight: 500 !important;
        line-height: 20px !important;
        opacity: 1 !important;
      }
    }
  }

  .date-picker-input {
    .MuiOutlinedInput-input {
      color: #e9e0e4;
      font-family: Quicksand, sans-serif;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
    }
  }
`
